import * as types from "../constants/actionTypes";
import * as msgs from "../constants/textConstants";
import Cookies from "cookies-js";
import { getDomain } from "../helpers/Tools";
import * as Tools from "../helpers/Tools";
import uuidv4 from "uuid/v4";

// IMPORTANT!!! -->> do not forget to add any fields in this model to the serverside model, otherwise the properties are stripped on serverside render
export const domainInitialState = {
    ds: null, // ds = Date saved
    li: false, // li = logged In
    lom: null, // lom = log out message
    hm: false, // hm = has MyChart
    ru: null, // ru = redirect URL
    hp: false, // hp = has Pharmacy
    hh: false, // hh = has HealthPlan
    rt: null, // rt = refresh token
    un: null, // un = healthsource UserName
    mc: null, // mc = MyChart ID
    amc:null, //amc = auto MyChart ID
    ei: null, // ei = Employee ID
    hi: null, // hi = HealthPlan ID
    ls: null, // ls = login status
    t: null, // t = token
    adt: null, /// adt = Active directory token
    cu: null, // cu = current user
    pu: null, // pu = primary user
    pl: null, // pl = proxy list
    nc: null, // nc = networkcode
    e: null, // e = email, 
    eid: null, // eid = EPID (from HealthSource API), 
    tk: null, // tk = token key
    ct: false, // ct = Can access thrive
    ie: false, // ie = is employee
    cpu: null, // cpu = current pharmacy user
    dto: null, // dto = datetime offset (gathered initially on the client and then passsed up to the server to make time adjustments on postbacks),
    ip: false, // ip = Is Proxy
    z: null, // z = zipc ode
    c: Cookies.get("bsw-CorrelationId") || uuidv4(),  //c = correlationId
    s: Cookies.get("bsw-SessionId") || uuidv4(), // s = sessionId
    fc: false, // Flu Consent
    ui: null,  // ui = HealthSource UserID (guid)
    mq: false,  // mq = Mobile per query string
    sb: false, // show custom graphics banner
    aal: false, // aal = has AAL
    aaal: false, //aaal = auto-aal
    lt: null, // latitude
    ln: null,  // longitude
    aaai: null, // AA auto ID
    aai: null,  // AA actual ID
    age: null,
    qp: null, // Redirect query params
    ix: false, //user has role Xealth_Member
    lan: null, // LAN Id
    dlan: null, // default Lan Id
    npi: null,  // NPI
    idt: null, // InstaDoc-BFF token
    et: null, // InstaDoc-BFF Employee Type
    er: null, // employee role (either 'provider' or 'staff')
    eids: null, // selected pair of department and provider epic ids
    srt: null, // signal R token
    sru: null,  // signal R url
    pen: null  //Provider external name
};

export const proxyListUser = {
    dn: null, // displayName
    ei: null, // externalId
    ii: null, // internalId
    mi: null, // myChartId
    eid: null, // eid
    ri: null, // relationshipId
    i: -1, // index
    ay: null, // age years
    im: false // isMinor
};


export const pharmacyProxyUser = {
    fn: null, // first name
    ln: null, // last name
    id: null, // pharmacy patient id
    i: null // index
};

// IMPORTANT!!! -->> do not forget to add any fields in this model to the serverside model, otherwise the properties are stripped on serverside render

export function compressProxyUser(pu) {
    if (pu && pu.displayName) {
        return {
            dn: pu.displayName,
            ei: pu.externalId,
            ii: pu.internalId,
            mi: pu.myChartId,
            eid: pu.eid,
            ri: pu.relationshipId,
            i: pu.index,
            ay: pu.ageYears,
            im: pu.isMinor
        };
    }
    return null;
}

export function hydrateProxyUser(cu) {
    if (cu && cu.dn) {
        return {
            displayName: cu.dn,
            externalId: cu.ei,
            internalId: cu.ii,
            myChartId: cu.mi,
            eid: cu.eid,
            relationshipId: cu.ri,
            index: cu.i,
            ageYears: cu.ay,
            isMinor: cu.im
        };
    }
    return null;
}

export function compressPharmacyUser(pu) {
    if (pu && pu.pharmacyPatientId) {
        return {
            fn: pu.firstName,
            ln: pu.lastName,
            id: pu.pharmacyPatientId,
            i: pu.index
        };
    }
}

export function hydratePharmacyUser(cu) {
    if (cu && cu.id) {
        return {
            firstName: cu.fn,
            lastName: cu.ln,
            pharmacyPatientId: cu.id,
            index: cu.i
        };
    }
}



export default function domainReducer(state = domainInitialState, action) {
    var myDomain = getDomain();
    const isServerSide = typeof window === "undefined";
    switch (action.type) {

        case types.SIGNALR_INIT:
            if (action.data) {
                return {
                    ...state,
                    srt: action.data.accessToken,
                    sru: action.data.url
                }
            }
            else {
                return {
                    ...state,
                    srt: null, 
                    sru: null
                }
            }

        case types.SET_PROVIDER_EPIC_IDS:
            return { ...state, eids: action.providerEpicIds };

        case types.INSTADOC_SET_EMPLOYEE:
            return {
                ...state,
                et: action.employeeType,
                er: action.employeeRole,
                eid: action.epicId,
                pen: action.providerExternalName
            };

        case types.INSTADOC_SET_TOKEN:
            return {
                ...state,
                idt: action.data.tokenString
            };

        case types.SET_PHYND_DATA:
            return {
                ...state,
                npi: action.data ? action.data.result[0].npi : null,
                eid: action.data ? action.data.result[0].epicID : null
            };

        case types.LOGIN_FORM_SUCCESS:
            return {
                ...state,
                s: uuidv4()
            };

        case types.LOGIN:
            return {
                ...state,
                s: uuidv4()
            };

        case types.CLEAR_USERLOGGEDOUT_MESSAGE:
            var sNewMessage = state.lom;
            if (sNewMessage === msgs.UserInitiatedLogoutMessage) {
                sNewMessage = null;
            }
            return { ...state, lom: sNewMessage };

        case types.LOGOUT_COMPLETED:
            //debugger;
            if (typeof window !== "undefined") {
                try { window.appInsights.clearAuthenticatedUserContext(); } catch (e) { }
            }
            //Cookies.set('authToken', "", { path: '/', domain: myDomain });
            //Cookies.set('refreshToken', "", { path: '/', domain: myDomain });
            if (typeof window !== "undefined") {
                window.currentUserName = null;
            }
            return {
                ...state,
                li: false,
                t: null,
                adt: null,
                rt: null,
                lom: action.logoutMessage || state.lom,
                hm: false,
                hp: false,
                hh: false,
                ls: action.type,
                un: null,
                mc: null,
                ei: null,
                hi: null,
                nc: null,
                e: null,
                cu: null,
                pu: null,
                pl: null,
                eid: null,
                tk: null,
                ct: false,
                ie: false,
                cpu: null,
                ip: false,
                z: null,
                s: uuidv4(),
                fc: false,
                ui: null,
                aal: false,
                aaal: false,
                lt: null,
                ln: null,
                aaai: null,
                aai: null,
                age: null,
                ix: false,
                lan: null,
                npi: null, 
                idt: null,
                adg: null
            };
        case types.USER_LOGGED_OUT:
            //debugger;
            if (typeof window !== "undefined") {
                try { window.appInsights.clearAuthenticatedUserContext(); } catch (e) { }

            }
            let oLogoutState = {
                ...state,
                lom: action.logoutMessage || state.lom,
                ru: action.DontClearRedirectURL ? state.ru : null,
                s: uuidv4()
            };
            //debugger;
            return oLogoutState;

        case types.GRAPHIC_BANNER_UPDATE:
            return {
                ...state,
                sb: false
            };

        case types.PROXY_LIST_LOADED:
            let Proxies = [];
            let currPrimUser = hydrateProxyUser(state.pu);  // preserve current primary and add missing values (then replace in the array)
            action.proxyList.forEach((c, index, arr) => {
                if (currPrimUser) {
                    //debugger;
                    if (currPrimUser.myChartId && c.myChartId && currPrimUser.myChartId.toUpperCase() === c.myChartId.toUpperCase()) {
                        //debugger;
                        currPrimUser.externalId = c.externalId;
                        currPrimUser.internalId = c.internalId;
                        currPrimUser.eid = c.eid;
                        currPrimUser.myChartId = c.myChartId; // this corrects the casing differences
                        currPrimUser.relationshipId = c.relationshipId;
                        currPrimUser.eVisit = c.eVisit;
                        currPrimUser.ageYears = c.ageYears;
                        currPrimUser.isMinor = c.isMinor;
                        c = currPrimUser;
                    }
                }
                Proxies.push(compressProxyUser(c));
            });
            let currCurrentUser = hydrateProxyUser(state.cu);
            if (!currCurrentUser) {
                currCurrentUser = currPrimUser;
            }
            //debugger;

            //let primaryUser = action.proxyList && action.proxyList.length > 0 ? action.proxyList[0] : null;
            //primaryUser = Proxies && Proxies.length > 0 ? Proxies[0] : null;

            return {
                ...state,
                pl: Proxies,
                pu: compressProxyUser(currPrimUser),
                cu: compressProxyUser(currCurrentUser)
            };

        case types.NO_USER_PROXY:
            return {
                ...state,
                pl: null
            };


        case types.USER_AUTHENTICATE_FAILURE:
            if (typeof window !== "undefined") {
                try { window.appInsights.clearAuthenticatedUserContext(); } catch (e) { }
            }
            return {
                ...state,
                ls: action.type
            };

        case types.USER_AUTHENTICATE:
            return {
                ...state,
                lom: null,
                ls: action.type,
                s: uuidv4()
            };

        case types.SET_HEALTH_SOURCE_TOKEN:
            //debugger;
            return {
                ...state,
                t: action.result.access_token,
                dlan: state.dlan ? state.dlan : action.result.LanID // dlan (default lan) is set only the first time
            };

        case types.SET_AD_ID_TOKEN:
            //debugger;
            return {
                ...state,
                adt: action.idToken,
            };

        case types.SET_AD_USER_DATA:
            //debugger;
            return {
                ...state,
                li: action.user && action.user.userName ? true : false,
                adt: window.sessionStorage.getItem("adal.idtoken"),
                //rt: action.userData.refresh_token,
                //hm: action.userData.Logins ? action.userData.Logins.toLowerCase().indexOf("mychart") !== -1 : false,
                //hp: action.userData.Logins ? action.userData.Logins.toLowerCase().indexOf('pharmacy') !== -1 : false,
                //hh: action.userData.Logins ? action.userData.Logins.toLowerCase().indexOf('healthplan') !== -1 : false,
                //ls: action.type,
                pu: compressProxyUser({ displayName: action.user.profile.given_name + ' ' + action.user.profile.family_name }),
                cu: compressProxyUser({ displayName: action.user.profile.given_name + ' ' + action.user.profile.family_name }),
                un: action.user.userName,
                //mc: action.userData.MyChartID,
                //ei: action.userData.EmpID,
                //hi: action.userData.HealthPlanID,
                //nc: action.userData.HealthPlanNetworkCode,
                e: action.user.userName,
                //eid: action.userData.EPID,
                tk: action.user.profile.aio,
                //z: action.userData.Zipcode,
                //fc: bFluConsent,
                //ie: action.userData.EmpID !== null && action.userData.EmpID !== "",
                //ui: action.userData.Id,
                //aal: action.userData.Logins ? action.userData.Logins.split(",").map(item => item.toLowerCase()).indexOf('aal') !== -1 : false,
                //aaal: action.userData.Logins ? action.userData.Logins.split(",").map(item => item.toLowerCase()).indexOf('auto-aal') !== -1 : false,
                //aaai: action.userData.AUTO_AAL,
                //aai: action.userData.AAL,
                sb: true,
                //age: action.userData.Age,
                //amc: action.userData.AUTO_MyChartID ? action.userData.AUTO_MyChartID : null,
                //ix: action.userData.Roles ? action.userData.Roles.toLowerCase().indexOf("xealth_member") !== -1 : false
            };


        case types.USER_AUTHENTICATE_SUCCESS:
            //debugger;
            const userData = action.userData;
            const displayName = (userData.Givenname || userData.GivenName) + ' ' + userData.Surname;
            const epid = userData.EPID;
            const mychart = userData.MyChartID;
            //Cookies.set('authToken', action.userData.access_token, { path: '/', domain: myDomain });
            //Cookies.set('refreshToken', action.userData.refresh_token, { path: '/', domain: myDomain });
            if (typeof window !== "undefined") {
                window.currentUserName = action.userData.userName; // we write this down here so anyone anywhere in any javascript can grab the value and run with it
                if (window.appInsights) {
                    try {
                        window.appInsights.setAuthenticatedUserContext(window.currentUserName);
                    }
                    catch (eee) {
                        console.error(eee);
                    }
                }

            }

            // Parse Consents
            var bFluConsent = false;
            var sConsents = userData.Consents;
            if (sConsents) {
                var sParts = sConsents.split(";");
                for (var i = 0; i < sParts.length; i++) {
                    if (sParts[i] !== "") {
                        var sParts2 = sParts[i].split("=");
                        if (sParts2.length > 1) {
                            if (sParts2[0] === "FLU") {
                                bFluConsent = (sParts2[1] === "1");
                                break;
                            }
                        }
                    }
                }
            }
            
            //debugger;
            return {
                ...state,
                li: action.userData && action.userData.access_token ? true : false,
                t: action.userData.access_token,
                rt: action.userData.refresh_token,
                hm: action.userData.Logins ? action.userData.Logins.toLowerCase().indexOf("mychart") !== -1 : false,
                hp: action.userData.Logins ? action.userData.Logins.toLowerCase().indexOf('pharmacy') !== -1 : false,
                hh: action.userData.Logins ? action.userData.Logins.toLowerCase().indexOf('healthplan') !== -1 : false,
                ls: action.type,
                pu: compressProxyUser({ displayName: displayName, epid: epid, myChartId: (mychart ? mychart : "") }),
                cu: state.cu ? state.cu : compressProxyUser({
                    displayName: displayName, epid: epid, myChartId: (mychart ? mychart : "")
                }),
                un: action.userData.userName,
                mc: action.userData.MyChartID,
                ei: action.userData.EmpID,
                hi: action.userData.HealthPlanID,
                nc: action.userData.HealthPlanNetworkCode,
                e: action.userData.Email,
                //eid: action.userData.EPID,
                tk: action.userData.TokenKey,
                z: action.userData.Zipcode,
                fc: bFluConsent,
                ie: action.userData.EmpID !== null && action.userData.EmpID !== "",
                ui: action.userData.Id,
                aal: action.userData.Logins ? action.userData.Logins.split(",").map(item => item.toLowerCase()).indexOf('aal') !== -1 : false,
                aaal: action.userData.Logins ? action.userData.Logins.split(",").map(item => item.toLowerCase()).indexOf('auto-aal') !== -1 : false,
                aaai: action.userData.AUTO_AAL,
                aai: action.userData.AAL,
                sb: true,
                age: action.userData.Age,
                amc: action.userData.AUTO_MyChartID ? action.userData.AUTO_MyChartID : null,
                ix: action.userData.Roles ? action.userData.Roles.toLowerCase().indexOf("xealth_member") !== -1 : false,
                lan: action.userData.LanID
            };
        case types.SET_REDIRECT_URL:
            // at no point do we want the redirect url to become either login or acceptterms
            let newURL = state.ru;
            let passedURL = action.URL;
            let params = '';
            if (action.params) {
                params = action.params;
            }
            if (passedURL && passedURL !== "/login" && passedURL !== "/acceptterms") {
                newURL = passedURL;
            }
            return { ...state, ru: newURL, qp: params };

        case types.CLEAR_REDIRECT_URL:
            //debugger;
            return { ...state, ru: null, qp:null };

        case types.SWITCH_USER_REDUCER:
            let au = action.user;
            let isProxyUser = !Tools.usersAreTheSame(hydrateProxyUser(state.pu), au);
            return {
                ...state,
                cu: compressProxyUser(au),
                ip: isProxyUser,
            };

        case types.SWITCH_TO_PHARMACY_USER:
            //console.log('pharmacy user switched', action.pharmacyUser);
            return { ...state, cpu: compressPharmacyUser(action.pharmacyUser) };

        case types.THRIVE:
            return {
                ...state,
                ct: action.thrive.canVisitThrive,
                //ie: action.thrive.employeeLoggedIn 
            };

        case types.GEOLOCATION_SUCCESS:
            return {
                ...state,
                lt: action.latitude,
                ln: action.longitude
            };
        case types.COOKIE_BSWPROXY_START:
            return { ...state, bswProxySwithcing: true };
        case types.COOKIE_BSWPROXY_SUCCESS:
            return { ...state, bswProxySwithcing: false };        
        default:
            let c = state.c;
            if (c === null) {
                //debugger;
                c = uuidv4();
            }
            return { ...state, dto: isServerSide ? state.dto : new Date().getTimezoneOffset(), c: c };

    }
}